import { ReactElement } from 'react';
import { useSearchData } from '@client/catalog/hooks';
import { useTranslate } from '@client/i18n/hooks';
import './CatalogTitle.scss';

interface Props {
  title: string;
}

export const CatalogTitle = ({ title }: Props): ReactElement | null => {
  const t = useTranslate();
  const { data } = useSearchData();
  const { productsCount } = data;
  const resultsText = !data
    ? ''
    : productsCount === 0
      ? `(${t('No results')})`
      : `(${t(['1 result', '{count} results', 'count'], { count: productsCount })})`;

  if (!title || !resultsText) {
    return null;
  }

  return (
    <h2 className='CatalogTitle'>
      {title}
      &nbsp;
      {title && resultsText}
    </h2>
  );
};
